<template>
  <div>
    <appHeader></appHeader>
    <div class="container-fluid transaction-report">
      <div class="row">
        <div class="col-md-3 col-sm-12 pr-0 dark-bg">
          <appDivvyAdminSidebar></appDivvyAdminSidebar>
        </div>
        <transition appear name="fade">
          <div class="col-md-9 p-4">
            <div>
              <div content-class="mt-3">
                <div class="button-tray mb-2">
                  <button
                    title="Invoices"
                    id="invoices"
                    :class="tab === 'invoices' ? 'activate' : ''"
                    @click="changeTab('invoices')"
                  >
                    <span>Invoices</span>
                  </button>

                  <button
                    title="Transactions"
                    id="transactions"
                    :class="tab === 'transactions' ? 'activate' : ''"
                    @click="changeTab('transactions')"
                  >
                    <span>Transactions</span>
                  </button>
                </div>
                <Invoices v-if="tab === 'invoices'" />
                <Transactions v-if="tab === 'transactions'" />
              </div>
            </div>
          </div>
        </transition>
      </div>
    </div>
    <appFooter class="footer"></appFooter>
  </div>
</template>

<script>
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import divvyAdminSidebar from "@/views/divvyadmin/divvyAdminSidebar.vue";
import Transactions from "./transactions/Transactions.vue";
import Invoices from "./invoices/Invoices.vue";

export default {
  name: "InvoicesAndTransaction",

  components: {
    appHeader: Header,
    appFooter: Footer,
    appDivvyAdminSidebar: divvyAdminSidebar,
    Transactions,
    Invoices,
  },

  data() {
    return {};
  },

  computed: {
    tab() {
      return this.$store.state.transactions.tab;
    },
  },

  methods: {
    changeTab(tab) {
      console.log(tab);
      this.$store.commit("transactions/TOGGLE_TAB", tab);
    },
    setActiveMenuItem: function() {
      this.$store.dispatch("divvyAdminSidebar/setActive", {
        activeMenuItem: this.activeMenuItem
          ? this.activeMenuItem
          : "invoicesAndTransactions",
        activeMenu: this.activeMenu
          ? this.activeMenu
          : "prefundingAndInvoicing",
      });
    },
  },

  created() {
    this.setActiveMenuItem();
  },
};
</script>

<style lang="scss" scoped>
.transaction-report {
  // margin: 70px 0 0 0;
  min-height: 100%;
  margin: -14px 0 0 0;
  .badge {
    font-size: 0.8rem;
    padding: 6px 0px;
    border-radius: $border-radius-sm;
  }
}

html,
body {
  height: 100%;
}

.btn-custom {
  background-color: aqua;
}

button {
  padding: 5px 10px;
  border-radius: 5px;
  margin-right: 10px;
  border: none;
  border: 1.5px solid white;
}

button:focus {
  outline: 0;
}

.activate {
  span {
    font-weight: bold;
  }
  border: 3px solid #3782f3;
}
</style>
